import request, { appendApiUrl } from '@/utils/request'
import { getUvid } from '@/utils/uvid'

/**
 * 查询排行榜单
 * @param {*} options
 * activityId 活动id
 * country 用户国家
 */
export const queryRankingList = (options = {}, configs = {}) => {
  return request.postJson(
    {
      url: appendApiUrl('/activity/ranking/list'),
      data: {
        ...options,
        time: Date.now(),
      },
    },
    {
      showLoading: configs.isLoading,
    }
  )
}

/**
 * 查某人的排行榜信息
 * @param {*} options
 * activityId	活动id
 * country	用户国家
 * kicoinId	ki币id
 * @returns
 */
export const queryInfo = (options = {}) => {
  return request.postJson({
    url: appendApiUrl('/activity/ranking/info'),
    data: {
      ...options,
      time: Date.now(),
    },
  })
}
/**
 * 点赞取消赞接口
 * @param {*} options
 * actionType 点赞取消赞
 * activityId 活动id
 * beLikeKicoinId 被点赞ki币id
 * country 用户国家
 * likeKicoinId 点赞ki币id
 * @returns
 */
export const likeSwitch = (options = {}) => {
  const opt = {
    uvid: getUvid(),
    ...options,
  }
  return request.postJson({
    url: appendApiUrl('/activity/ranking/like'),
    data: {
      ...opt,
      time: Date.now(),
    },
  })
}

/**
 * 查询某人给谁点过赞
 * @param {*} options
 * activityId 活动id
 * country 用户国家
 * kicoinId ki币id
 */
export const querySomeoneLikes = (options = {}) => {
  return request.postJson({
    url: appendApiUrl('/activity/ranking/query/like'),
    data: {
      ...options,
      time: Date.now(),
    },
  })
}
